import substitution from '@ihs-widget/assets/svg/lineup/substitution_light.svg';
import goal from '@ihs-widget/assets/svg/lineup/goal_light.svg';
import injury from '@ihs-widget/assets/svg/lineup/injury_light.svg';
import yellowCard from '@ihs-widget/assets/svg/lineup/yellow_card_light.svg';
import secondYellowCard from '@ihs-widget/assets/svg/lineup/second_yellow_card_light.svg';
import redCard from '@ihs-widget/assets/svg/lineup/red_card_light.svg';
import assist from '@ihs-widget/assets/svg/lineup/assist_light.svg';
import ownGoal from '@ihs-widget/assets/svg/lineup/own_goal_light.svg';
import { useTheme } from '@ihs-widget/stores/ThemeContext';
import { T } from "@ihs-widget/utils/enums";
import { useVersion } from '@ihs-widget/utils/hooks/useVersion';

interface SubstitutionTime {
    in: number | null;
    out: number | null;
}

interface ShirtIconProps {
    type:
    'substitutionTime' |
    'substitution' |
    'yellowCard' |
    'secondYellowCard' |
    'redCard' |
    'goal' |
    'ownGoal' |
    'goalAndOwnGoal' |
    'assist' |
    'xGoals' |
    'shots' |
    'ballTouches' |
    'injury' |
    'empty';
    substitutionTime?: SubstitutionTime | null;
    goals?: number | null;
    own_goal?: number | null;
    assists?: number | null;
    xGoals?: number | null;
    shots?: number | null;
    ballTouches?: number | null;
    yellowCards?: number | null;
    mb?: string;
    mt?: string;
    isHorizontalList?: boolean;
    isLineup?: boolean;
}

const ShirtIcon = ({
    type,
    substitutionTime = null,
    goals = null,
    own_goal = null,
    assists = null,
    xGoals = null,
    shots = null,
    ballTouches = null,
    yellowCards = null,
    mb = 'mb-[2px]',
    mt = 'mt-0',
    isHorizontalList = false,
    isLineup = true
}: ShirtIconProps) => {
    const { theme } = useTheme();
    const { isV2 } = useVersion();

    // TODO: console log here, is to many rerenders
    
    switch (type) {
        
        case 'substitutionTime':
            return <div data-testid="shirt-icon-substitution-time" className={`w-[16px] h-[16px]
                            font-robotoRegular font-normal text-[12px] leading-[16px] ${mb} 
                            flex justify-center items-center`}
                            style={{ color: isLineup ? '#FFFFFF' : (theme === T.DARK ? '#FFFFFF' : '#111111') }}>
                {`${substitutionTime?.in && !substitutionTime?.out ? substitutionTime?.in+`'` : ''}`}
                {`${substitutionTime?.out ? substitutionTime?.out+`'` : ''}`}
            </div>
        case 'substitution':
            return <div data-testid="shirt-icon-substitution" className={`w-[16px] h-[16px] rounded-[6px] bg-monoY
                                  flex justify-center items-center ${mb} ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                <img src={substitution} alt="substitution" />
            </div>
        case 'injury':
            return <div data-testid="shirt-icon-injury" className={`w-[16px] h-[16px] rounded-[6px] bg-monoY
                                  flex flex-row justify-center items-center ${mb} ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                <img src={injury} alt="injured" />
            </div>
        case 'yellowCard':
            return <div data-testid="shirt-icon-yellow-card" className={`w-[16px] h-[16px] rounded-[6px] bg-monoY
                                  flex justify-center items-center ${mb} ${mt} ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                <img className={`w-[12px] h-[12px]`} src={yellowCard} alt="yellowCard" />
            </div>
        case 'secondYellowCard':
            return <div data-testid="shirt-icon-second-yellow-card" className={`w-[16px] h-[16px] rounded-[6px] bg-monoY
                                  flex justify-center items-center ${mb} ${mt} ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                <img className={`w-[12px] h-[12px]`} src={secondYellowCard} alt="secondYellowCard" />
            </div>
        case 'redCard':
            return <div data-testid="shirt-icon-red-card" className={`w-[16px] h-[16px] rounded-[6px] bg-monoY
                                  flex justify-center items-center ${mb} ${mt} ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                <img className={`w-[12px] h-[12px]`} src={redCard} alt="redCard" />
            </div>
        case 'goal':
            return (
                <div data-testid="shirt-icon-goal" className={`min-w-[16px] h-[16px] rounded-[6px] bg-monoY
                                flex justify-center items-center px-[2px] ${goals && goals > 1 ? 'gap-[2px]' : ''} ${mb} 
                                ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}
                                
                                >
                    <img src={goal} alt="goal" />
                    <div className={`text-base120 font-robotoRegular font-normal text-[12px] leading-[16px] 
                        ${goals && goals > 1 ? 'ml-0' : ''}`}>
                        {`${goals && goals > 1 ? goals : ''}`}
                    </div>
            </div>
        )
        case 'ownGoal':
            return (
                <div data-testid="shirt-icon-own-goal" className={`min-w-[16px] h-[16px] rounded-[6px] bg-monoY
                                flex justify-center items-center px-[2px] ${goals && goals > 1 ? 'gap-[2px]' : ''} ${mb} 
                                ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}
                                
                                >
                    <img src={ownGoal} alt="ownGoal" />
                    <div className={`text-base120 font-robotoRegular font-normal text-[12px] leading-[16px] 
                        ${own_goal && own_goal > 1 ? 'ml-0' : ''}`}>
                        {`${own_goal && own_goal > 1 ? own_goal : ''}`}
                    </div>
                </div>
        )

        case 'goalAndOwnGoal':
            return (
                <div data-testid="shirt-icon-own-goal" className={`min-w-[16px] h-[16px] rounded-[6px] bg-monoY
                                flex justify-center items-center px-[2px] ${goals && goals > 1 ? 'gap-[2px]' : ''} ${mb} 
                                ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}
                                
                                >
                    <div className={`flex flex-row gap-px`}>
                        <img src={ownGoal} alt="ownGoal" />
                        <div className={`text-base120 font-robotoRegular font-normal text-[12px] leading-[16px] 
                            ${own_goal && own_goal > 1 ? 'ml-0' : ''}`}>
                            {`${own_goal && own_goal > 1 ? own_goal : ''}`}
                        </div>

                        <img src={goal} alt="goal" />
                        <div className={`text-base120 font-robotoRegular font-normal text-[12px] leading-[16px] 
                            ${goals && goals > 1 ? 'ml-0' : ''}`}>
                            {`${goals && goals > 1 ? goals : ''}`}
                        </div>
                    </div>

                </div>
        )
        case 'assist':
            return (
                <div data-testid="shirt-icon-assist" className={` w-fit absolute right-0 h-[16px] rounded-[6px] bg-monoY
                                flex justify-center items-center 
                                ${assists && assists > 1 && assists < 10 ? 'min-w-[25px]' : ''} 
                                ${assists && assists > 9 ? 'min-w-[33px]' : ''} 
                                ${mb}
                                ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`} >
                    <img src={assist} alt="assist" className='ml-[2px]' />
                    <div className={`text-base120 font-robotoRegular font-normal text-[12px] 
                                    leading-[16px] mr-[2px]
                                    ${assists && assists > 1 ? 'ml-[2px]' : ''}`}>
                        {`${assists && assists > 1 ? assists : ''}`}
                    </div>
                </div>
            )
        case 'xGoals':
            return (
                <div data-testid="shirt-icon-xGoals">
                    <div className={`min-w-[16px] w-fit h-[16px] rounded-[6px] bg-monoY
                    flex justify-center items-center px-[2px] ${mb} absolute right-0 ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                        <div className={`text-base120 font-robotoRegular 
                            font-normal text-[12px] leading-[16px] `}>
                            {`${xGoals}`}
                        </div>
                    </div>
                    <div className={`h-[18px] w-[16px]`}>
                    </div>
                </div>
            )
        case 'shots':
            return (
                <div data-testid="shirt-icon-shots">
                    <div className={`min-w-[16px] w-fit h-[16px] rounded-[6px] bg-monoY
                    flex justify-center items-center px-[2px] ${mb}  absolute right-0 ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                        <div className={`text-base120 font-robotoRegular 
                            font-normal text-[12px] leading-[16px] `}>
                            {`${shots}`}
                        </div>
                    </div>
                    <div className={`h-[18px] w-[16px]`}>
                    </div>
                </div>
            )
        case 'ballTouches':
            return (
                <div data-testid="shirt-icon-ball-touches">
                    <div className={`min-w-[16px] w-fit h-[16px] rounded-[6px] bg-monoY
                    flex justify-center items-center px-[2px] ${mb}  absolute right-0 ${isHorizontalList ? 'outline-solid outline-[0.6px] outline-base090' : ''}`}>
                        <div className={`text-base120 font-robotoRegular 
                            font-normal text-[12px] leading-[16px] `}>
                            {`${ballTouches}`}
                        </div>
                    </div>
                    <div className={`h-[18px] w-[16px]`}>
                    </div>
                </div>
            )
        case 'empty':
            return <div data-testid="shirt-icon-empty" className={`w-[16px] h-[16px] ${mb}`}></div>;

        default:
            return <div data-testid="shirt-icon-empty" className={`w-[16px] h-[16px] ${mb}`}></div>;
    }
}

export default ShirtIcon;